import { useApolloClient, useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { ApplicationPageFormValues } from '@presentation/pages';
import { useCallback, useState } from 'react';
import { ACCOUNT_GET_BUYER_APPLICATIONS } from '../account/applications/useGetBuyerApplications';

export const CREATE_APPLICATION_FOR_SUGGESTED_BREEDER = graphql(`
  mutation CreateApplicationForSuggestedBreeder($data: CreateApplicationInput!) {
    confirmCreateApplication(data: $data) {
      id
    }
  }
`);

export const useCreateApplicationsForSuggestedBreeders = () => {
  const [confirmCreateApplication] = useMutation(CREATE_APPLICATION_FOR_SUGGESTED_BREEDER);
  const [loading, setLoading] = useState(false);
  const apolloClient = useApolloClient();

  const createApplicationsForSuggestedBreeders = useCallback(
    async (breederValues: { [key: string]: ApplicationPageFormValues }) => {
      setLoading(true);

      await Promise.all(
        Object.keys(breederValues).map((key) => {
          const values = breederValues[key];
          const dogBreederId = Number(key.split('-')[0]);
          if (Number.isNaN(dogBreederId)) {
            throw new Error('Dog breeder id must be a number');
          }

          return confirmCreateApplication({
            variables: {
              data: {
                accommodation: values.accommodation!,
                dogBreedId: values.breedPreferenceId!,
                dogBreederId: Number(key.split('-')[0]),
                experiences: values.experiences!,
                genderPreferences: values.genderPreferences!,
                otherAnimals: values.otherAnimals!,
                timeAlone: values.timeAlone!,
                trainers: values.trainers!,
              },
            },
            context: {
              debounceKeyRaw: key,
            },
          });
        }),
      );

      apolloClient.refetchQueries({
        include: [ACCOUNT_GET_BUYER_APPLICATIONS],
      });

      setLoading(false);
    },
    [apolloClient, confirmCreateApplication],
  );

  return {
    createApplicationsForSuggestedBreeders,
    createApplicationsForSuggestedBreedersLoading: loading,
  };
};
